import styled from 'styled-components';

export const Container = styled.section`
  padding: 20px 0 8px;
`;

export const RangeArea = styled.div`
  padding: 0 12px;
`;

export const ValuesArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

export const Value = styled.span`
  font-size: 14px;
  color: ${({ theme }) => theme.filters.color};

  @media ${({ theme }) => theme.device.desktop} {
    font-size: 12px;
  }
`;
